import React from "react";
import "./TeamcenterAWClientPage.css";
import { NavLink } from "react-router-dom";
import BannerImage from "../../../assets/other_image/implimentation_AWc.jpg";
import TeamcenterAWClientOverview from "./TeamcenterAWClientOverview";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";

const TeamcenterAWClientPage = () => {
  return (
    <>
     <Helmet>
      <title>Teamcenter Active Workspace (AW) Client Services in Pune| NexTech PLM</title>
      <meta name="description" content="Enhance collaboration with Teamcenter AW Client services in Pune, India. Nextech PLM delivers efficient PLM solutions tailored to your needs." />
      <meta name="keywords" content="Teamcenter Active Workspace implementation, AW client customization Pune, Teamcenter web client India, Active Workspace deployment, Teamcenter AW configuration" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href="https://nextechplm.com/teamcenter-aw-client" />
      <meta property="og:site_name" content="NexTech PLM Solutions" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Teamcenter Active Workspace (AW) Client Services in Pune| NexTech PLM" />
      <meta property="og:description" content="Enhance collaboration with Teamcenter AW Client services in Pune, India. Nextech PLM delivers efficient PLM solutions tailored to your needs." />
      <meta property="og:url" content="https://nextechplm.com/teamcenter-aw-client" />
      <meta property="og:image" content="https://nextechplm.com/logo192.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Teamcenter Active Workspace (AW) Client Services in Pune| NexTech PLM" />
      <meta name="twitter:description" content="Enhance collaboration with Teamcenter AW Client services in Pune, India. Nextech PLM delivers efficient PLM solutions tailored to your needs." />
      <meta name="twitter:image" content="https://nextechplm.com/logo192.png" />
</Helmet>

          <section className="TeamcenterAWClient-process">

<Banner
        image={BannerImage} // Pass the image for this page
        heading="Implementation of Teamcenter AW Client" // Pass the heading text for this page
      />      
<div>
         <FloatingContactUs />
      </div>

      <TeamcenterAWClientOverview/>

      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="solution-page-heading">Unlock the Power :</h4>
          <h5 className="solution-subheading">
            Discover the Transformative Benefits of Implementation of Teamcenter AW Client with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
            Comprehensive Active Workspace Client Setup for Enhanced User Experience 
            </li>
            <li>Efficient Background Task Processing for Seamless Workflow Management </li>
            <li>
            Robust Document Management Capabilities for Versatile Handling of Data 
            </li>
            <li>
            Advanced Configuration and Integration of Various Tools and Systems 
            </li>
            <li>
            Streamlined Installation, Configuration, and Testing Processes for Enhanced Performance 
            </li>
          
          </ul>
        </div>
      </section>

      <section>
  <div className="solutions container">
    <div className="solutions-content">
      <div className="row">
        <div className="col-md-6 col-12">
          <h4 className="solution-page-heading">Teamcenter Solutions</h4>
          <p className="plmimplementationparagraph">
            NexTech PLM Solutions provide comprehensive services for the Active Workspace Client, enabling companies to leverage the full benefits of this revolutionary client within their business context.
          </p>
          <ul className="custom-bullets">
            <li>Installation</li>
            <li>Implementation</li>
            <li>Upgradation</li>
            <li>Configuration</li>
            <li>Customization</li>
            <li>Site Consolidation</li>
            <li>Web SEAL SSL Configuration</li>
            <li>Training and resources on contract to enable Active Workspace Client in the context of your business requirements.</li>
            <li>RAC to AWC Migrations</li>
            <li>Multifactor Authentications</li>
            <li>MCAD Integration</li>
            <li>ECAD Integration</li>
          </ul>
        </div>
        <div className="col-md-6 col-12">
          <div className="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <NavLink to={"/teamcenter/cloud-implementation"}>
                  Teamcenter Implementation on Cloud
                </NavLink>
              </li>
              <li>
                <NavLink to={"/teamcenter/implementation"}>
                  Teamcenter Implementation
                </NavLink>
              </li>
              <li>
                <NavLink to={"/teamcenter/cae-integration"}>
                  Teamcenter Integration for CAE
                </NavLink>
              </li>
              <li>
                <NavLink to={"/teamcenter/cam-integration"}>
                  Teamcenter Integration for CAM
                </NavLink>
              </li>
              <li>
                <NavLink to={"/teamcenter/performance-tuning-health-checkup"}>
                  Teamcenter Performance Tuning & Health Check-up
                </NavLink>
              </li>
              <li>
                <NavLink to={"/teamcenter/program-project-management"}>
                  Teamcenter Project Management
                </NavLink>
              </li>
              <li>
                <NavLink to={"/teamcenter/rac-to-aw-client-transition"}>
                  Teamcenter RAC to Active Workspace Client Transition
                </NavLink>
              </li>
              <li>
                <NavLink to={"/teamcenter/upgrade-migration"}>
                  Teamcenter Upgrade & Migration
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


      <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="solution-page-heading">Why NexTech?</h4>
          <h5 className="solution-subheading">
            For Implementation of Active Workspace Client
          </h5>
          <ul className="custom-bullets">
            <li>
            Expertise in configuring Active Workspace Client for superior user experience across diverse devices. 
            </li>
            <li>
            Proficiency in implementing background task processing for seamless workflow management. 
            </li>
            <li>
            Strong capabilities in robust document management for versatile data handling. 
            </li>
            <li>
            Advanced skills in integrating various tools and systems for enhanced functionality. 
            </li>
            <li>
            Experience in streamlined installation, configuration, and testing processes for optimized performance. 
            </li>
          </ul>
        </div>
      </section>

      <Letsgetintouch />
      
    </section>
</>
  );
};

export default TeamcenterAWClientPage;
